var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgActivities = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "activities",
    d: "M16.969 4.172l-.04-.041c-.38-.393-.998-.394-1.38 0l-1.485 1.555c-.078.082-.203.085-.285.007l-2.081-1.991c-.203-.194-.466-.3-.741-.3H7.86c-.073 0-.143.029-.196.08L5.039 6.066c-.384.398-.41 1.04-.058 1.432.188.21.442.325.716.325H5.7c.271-.002.532-.121.712-.325l1.854-2.033h.663l-4.326 5.01H1.936c-.633 0-1.153.49-1.184 1.115-.017.327.093.637.31.874.214.234.515.368.826.368h3.981c.079 0 .154-.034.208-.094l2.04-2.256 1.715 1.859-.518 3.429c-.13.568.133 1.147.626 1.375.152.07.313.106.473.106.173 0 .345-.041.503-.122.305-.157.525-.443.605-.8l.884-4.917c.018-.095-.012-.194-.078-.262L9.965 8.706l1.876-1.941 1.308 1.354c.365.379 1.002.379 1.367 0l2.453-2.541c.181-.188.281-.438.281-.703 0-.265-.1-.515-.281-.703z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "activities",
    d: "M13.832 4.286c.941 0 1.707-.793 1.707-1.768S14.773.75 13.832.75c-.94 0-1.706.793-1.706 1.768s.765 1.768 1.706 1.768z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActivities, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/activities.09bd4e9d.svg";
export { ForwardRef as ReactComponent };